var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAddUserDark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "add_user",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    style: {
      fill: "currentColor"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_23590",
    "data-name": "Path 23590",
    d: "M0,0H20V20H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3700",
    "data-name": "Path 3700",
    d: "M10.769,7.527a7.623,7.623,0,0,0-.882-.354,3.984,3.984,0,1,0-4.771,0A7.621,7.621,0,0,0,.038,12.853,1.78,1.78,0,0,0,1.778,15H8.994a.586.586,0,0,0,0-1.172H1.778a.6.6,0,0,1-.469-.223.612.612,0,0,1-.124-.513A6.474,6.474,0,0,1,7.345,7.966q.077,0,.155,0t.157,0a6.382,6.382,0,0,1,2.609.619.586.586,0,0,0,.5-1.058ZM7.643,6.793H7.359a2.813,2.813,0,1,1,.285,0Z",
    transform: "translate(2.499 2.5)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3701",
    "data-name": "Path 3701",
    d: "M326.98,324.2h-1.611v-1.611a.586.586,0,1,0-1.172,0V324.2h-1.611a.586.586,0,1,0,0,1.172H324.2v1.611a.586.586,0,1,0,1.172,0v-1.611h1.611a.586.586,0,1,0,0-1.172Z",
    transform: "translate(-310.066 -310.066)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddUserDark);
export default __webpack_public_path__ + "static/media/add_user_dark.e94b048872c22621f28165e8ab1518b4.svg";
export { ForwardRef as ReactComponent };